import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const OptimismLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="nonzero"><rect fill="#FF0420" height={24} rx={0} width={24} /><path d="M7.81 15.641c-.804 0-1.462-.188-1.975-.566-.507-.383-.76-.933-.76-1.64 0-.15.016-.329.049-.544.086-.486.21-1.068.372-1.753.458-1.855 1.645-2.783 3.554-2.783.518 0 .987.086 1.397.264.41.167.733.426.97.772.238.34.356.744.356 1.213 0 .14-.016.318-.048.534a21.886 21.886 0 0 1-.367 1.753c-.237.922-.642 1.618-1.224 2.076-.577.453-1.354.674-2.325.674Zm.145-1.456c.378 0 .696-.113.96-.334.27-.221.464-.561.577-1.025a23.96 23.96 0 0 0 .356-1.661c.027-.14.043-.286.043-.437 0-.615-.318-.922-.96-.922-.377 0-.7.113-.97.334-.265.221-.454.561-.567 1.025a21.67 21.67 0 0 0-.367 1.661 2.152 2.152 0 0 0-.043.426c-.005.626.324.933.971.933Zm4.288 1.36c-.076 0-.13-.022-.173-.07a.263.263 0 0 1-.032-.184l1.397-6.58a.269.269 0 0 1 .113-.183.297.297 0 0 1 .194-.07h2.691c.75 0 1.349.156 1.802.463.458.313.69.76.69 1.349 0 .167-.022.345-.06.528-.167.777-.506 1.348-1.024 1.72-.507.373-1.203.556-2.087.556h-1.365l-.464 2.217a.29.29 0 0 1-.113.183.297.297 0 0 1-.194.07h-1.375Zm3.58-3.868c.287 0 .53-.075.74-.232.215-.156.356-.377.426-.668a1.65 1.65 0 0 0 .032-.302c0-.195-.06-.346-.172-.448-.114-.108-.313-.162-.588-.162h-1.214l-.383 1.812h1.16Z" fill="#FFF" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const OptimismLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0ZM9.05 8.355c-1.91 0-3.096.928-3.554 2.783a32.765 32.765 0 0 0-.372 1.753 3.737 3.737 0 0 0-.049.544c0 .707.253 1.257.76 1.64.513.378 1.17.566 1.974.566.971 0 1.748-.22 2.325-.674.582-.458.987-1.154 1.224-2.076.146-.567.264-1.154.367-1.753.032-.216.048-.394.048-.534 0-.47-.118-.874-.355-1.213a2.123 2.123 0 0 0-.971-.772c-.41-.178-.88-.264-1.397-.264Zm7.383.102h-2.691a.297.297 0 0 0-.194.07.269.269 0 0 0-.113.184l-1.397 6.58c-.011.07 0 .13.032.183.043.049.097.07.173.07h1.375c.07 0 .135-.021.194-.07a.29.29 0 0 0 .113-.183l.464-2.217h1.365c.884 0 1.58-.183 2.087-.555.518-.373.857-.944 1.025-1.72.037-.184.059-.362.059-.53 0-.587-.232-1.035-.69-1.348-.453-.307-1.052-.464-1.802-.464ZM8.931 9.806c.642 0 .96.307.96.922 0 .151-.016.297-.043.437-.08.475-.2 1.025-.356 1.661-.113.464-.307.804-.577 1.025a1.445 1.445 0 0 1-.96.334c-.647 0-.976-.307-.97-.933 0-.15.015-.291.042-.426a21.67 21.67 0 0 1 .367-1.661c.113-.464.302-.804.566-1.025.27-.22.594-.334.971-.334Zm7.33.06c.275 0 .474.053.588.16.113.103.172.254.172.449 0 .086-.01.188-.032.302-.07.29-.21.512-.426.668-.21.157-.453.232-.74.232h-1.159l.383-1.812Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};